export function footerAccordion() {
    let triggerSelector = ".drop-label";
    let $nestedLists = $(".nav-list-nested");

    for (let i = 0; i < $nestedLists.length; i++) {

        if ( !$($nestedLists[i]).closest(".footer-accordion-item").hasClass("has-second-level")) {
            $($nestedLists[i]).closest(".footer-accordion-item").addClass("has-second-level");
        }
    }

    $(document).on("click", triggerSelector, function () {

        if ( !$(this).parent().hasClass("nav-list-nested") && $(window).width() >= 1200 ) {
            return;
        }

        let $this = $(this);
        let filtersList = $this.siblings("ul");
        filtersList.stop().slideToggle(200);
        $this.parent().toggleClass("expanded");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/footerAccordion.js